
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import ChallengerDetailCommunityUsers from './by-list/ChallengerDetailCommunityUsers.vue';
  import ChallengerDetailCommunityMap from './by-map/ChallengerDetailCommunityMap.vue';
  import {challengeCommunityModule, challengeCommunityState, challengeModule} from '@/utils/store-acessor';
  import {UserModel} from '@/models/user.model';
  import {ChallengeModel} from '@/models/challenge.model';

  @Component({
    components: {
      ChallengerDetailCommunityUsers,
      ChallengerDetailCommunityMap
    }
  })
  export default class ChallengerDetailCommunity extends Vue {
    @challengeCommunityModule.Getter('users') users!: UserModel[];
    @challengeModule.Getter('selectedChallenge') readonly challenge!: ChallengeModel;

    showUserList = false;

    mounted() {
      if (this.challenge?.id) {
        challengeCommunityState.fetchCommunity(this.challenge.id)
      }
    }

    formatTitle(users: number): string {
      if (users > 1) {
        return this.$tc('challenge.users', 2, {count: users}).toString();
      } else {
        return this.$tc('challenge.users', 1, {count: users}).toString()
      }
    }

    usersCount(){
      return this.formatTitle(this.challenge?.contestants_count || 0);
    }
  }
